import { render } from "./FirebaseUserRevertSecondFactorAddition.vue?vue&type=template&id=562cc7f1"
import script from "./FirebaseUserRevertSecondFactorAddition.vue?vue&type=script&lang=js"
export * from "./FirebaseUserRevertSecondFactorAddition.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ra/Desktop/experiments/benchomatic/src/core-auth/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__